import permissions from "./../../data/permissions"
export default [
    {
        name: "Requisitions",
        path: "requisitions",
        component: () => import("./../../views/warehouse/RequisitionListView.vue"),
        meta: { requiresAuth: true, authorization: permissions.purchase_requisition.index }

    },
    {
        name: 'Requisition',
        path: "requisition/:id",
        component: () => import("./../../views/warehouse/RequisitionDisplayView.vue"),
        meta: { requiresAuth: true, authorization: permissions.purchase_requisition.read }

    },
    {
        name: "RequisitionCreate",
        path: "requisition",
        component: () => import("./../../views/warehouse/RequisitionCreateView.vue"),
        meta: { requiresAuth: true, authorization: permissions.purchase_requisition.create }
    },
    {
        name: "RequisitionEdit",
        path: "requisition/:id/edit",                                                                   
        component: () => import('./../../views/warehouse/RequisitionEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.purchase_requisition.update }
    },   
]